const logs = {
    page_title: 'Записи аудита',
    title: 'Записи аудита',
    subtitle: 'Просмотр данных журнала событий аутентификации, сделанных вашими пользователями',
    event: 'Событие',
    user: 'Пользователь',
    application: 'Приложение',
    time: 'Время',
    filter_by: 'Фильтр по',
    last_1_hour: 'Последний час',
    last_24_hours: 'Последние 24 часа',
    last_7_days: 'Последние 7 дней',
    last_30_days: 'Последние 30 дней',
    custom_range: 'Произвольный период',
    from: 'С',
    to: 'По',
};
export default Object.freeze(logs);
